// TopicWrap.js
import {
    defineComponent,
    ref,
    computed,
    watch,
} from "/Scripts/vue.esm-browser.js";
import PromSection from "./product/PromSection.js";
import MarketingSection from "./product/MarketingSection.js";
const html = String.raw;

export default defineComponent({
    name: "TopicWrap",
    components: {
        PromSection,
        MarketingSection,
    },
    props: {
        promoData: {
            type: Array,
        },
        marketingData: {
            type: Array,
        },
        correspond: {
            type: Array,
        },
        prom: {
            type: String
        },
        isResolved: {
            type: Boolean,
            default: false,
        },
        hasContent: {
            type: Boolean,
            default: false,
        }
    },
    emits: [],
    setup(props, { emit }) {
        const currentTab = ref("prom"); // 預設顯示優惠活動
        const hasPromoData = computed(() => props.promoData.length > 0);
        const hasMarketingData = computed(() => props.marketingData.length > 0);

        const setTab = (tab) => {
            currentTab.value = tab;
        };

        watch(
            () => [hasPromoData.value, hasMarketingData.value, props.isResolved],
            ([promoReady, marketingReady]) => {
                if (promoReady) {
                    currentTab.value = "prom";
                    return;
                }
                if (marketingReady) {
                    currentTab.value = "marketing";
                }
            },
            { immediate: true },
        );

        return {
            currentTab,
            setTab,
            hasPromoData,
            hasMarketingData,
        };
    },
    template: html`
        <div
            class="topic_wrap"
            v-if="!isResolved || hasContent"
            :class="{ 'topic_wrap--placeholder': !isResolved }"
        >
            <template v-if="!isResolved">
                <div class="title_section topic_placeholder__title"></div>
                <div class="topic_tab_wrap topic_placeholder__tabs">
                    <div class="tab-btn topic_placeholder__tab"></div>
                    <div class="tab-btn topic_placeholder__tab"></div>
                </div>
                <div class="topic_placeholder__cards">
                    <div class="topic_placeholder__card" v-for="idx in 4" :key="idx"></div>
                </div>
            </template>

            <template v-else>
                <div class="title_section">熱門主題</div>

                <div class="topic_tab_wrap">
                    <div
                        v-if="hasPromoData"
                        class="topic_discount tab-btn"
                        :class="{ active: currentTab === 'prom' }"
                        @click="setTab('prom')"
                        data-target="layout-1"
                    >
                        優惠活動
                    </div>
                    <div
                        v-if="hasMarketingData"
                        class="topic_marketing tab-btn"
                        :class="{ active: currentTab === 'marketing' }"
                        @click="setTab('marketing')"
                        data-target="layout-2"
                    >
                        流行玩什麼
                    </div>
                </div>

                <prom-section
                    :promo-data="promoData"
                    :current-tab="currentTab"
                    :correspond="correspond"
                    :prom="prom"
                ></prom-section>
                <marketing-section
                    :marketing-data="marketingData"
                    :current-Tab="currentTab"
                ></marketing-section>
            </template>
        </div>
    `,
    methods: {},
});
